import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Button,
  CardContent, 
  Checkbox, 
  CircularProgress, 
  FormControlLabel, 
  FormGroup, 
  Typography, 
  Zoom,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { financialService } from '../utils/api';
import { useAppContext } from '../context/AppContext';
import CONFIG from '../utils/config';

function SubmitPage() {
  const { state, actions } = useAppContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [timeoutDialogOpen, setTimeoutDialogOpen] = useState(false);
  const [value, setValue] = useState({
    receiveReport: state.receiveReport,
    requestCallback: state.requestCallback,
  })

  useEffect(() => {
    actions.updateFormData('submissionSuccess', false);
    setValue({
      receiveReport: state.receiveReport,
      requestCallback: state.requestCallback,
    })
  }, [state.receiveReport, state.requestCallback]);
  
  const handleCheckboxChange = (event) => {
    const key = event.target.name;
    const value = event.target.checked
    console.log(key, value)
    actions.updateFormData(key, value);
    setValue(prev => ({ ...prev, key: value }));
  };
  
  const handleSubmit = async () => {
    setIsSubmitting(true);
  
    try {
      actions.updateFormData('submissionSuccess', true);
  
      // Submit main request
      try {
        await financialService.submitRequest({
          "clientName": state.clientName,
          "emailId": state.email,
          "phoneNumber": state.phoneNumber,
          "birthYear": state.birthYear,
          "age": state.age,
          "retirementAge": state.retirementAge,
          "yearlyExpenses": state.monthlyExpensesInRetirement,
          "corpusRequired": state.corpusRequired,
          "goals": state.goals || [],
          "kidsEducation": state.kidsEducation || [],
          "riskProfile": state.riskProfile,
          "emergency_funds": state.emergencyFunds,
          "amountRequiredToday": state.amountRequiredToday,
          "currentInvestment": state.netWorth,
          "fundingScore": state.fundingScore || 0,
          "requiredRateOfReturn": 0,
          "phoneNumberVerified": true,
          "city": state.city,
          "receiveReport": state.receiveReport,
          "receiveGuide": false,
          "requestCallback": state.requestCallback
        });
        console.log("Submit Request API success");
      } catch (error) {
        console.error("Submit Request failed:", error);
      }
  
      // Submit Life Goals
      // for (const goal of state.goals) {
      //   try {
      //     await financialService.submitGoals(state.phoneNumber, {
      //       goal_type: goal.type,
      //       current_value: goal.currentValue,
      //       target_date: goal.targetYear,
      //       future_value: goal.FV_goal
      //     });
      //     console.log("Goals API success");
      //   } catch (error) {
      //     console.error("Error submitting goal:", error);
      //   }
      // }
  
      // Submit Kids Education Info
      for (const kidEdu of state.kidsEducation) {
        try {
          await financialService.submitChildrenInfo(state.phoneNumber, {
            name: kidEdu.name,
            year_of_birth: kidEdu.yearOfBirth,
            age: kidEdu.Age,
            ug_college: kidEdu.ug,
            ug_college_fees: kidEdu.ug_fees,
            ug_college_fees_fv: Math.max(kidEdu.ug_fees_FV, kidEdu.ug_fees),
            pg_college: kidEdu.pg,
            pg_college_fees: kidEdu.pg_fees,
            pg_college_fees_fv: Math.max(kidEdu.pg_fees_FV, kidEdu.pg_fees)
          });
          console.log("Kid Edu API success");
        } catch (error) {
          console.error("Error submitting Kid Edu:", error);
        }
      }
  
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 401) {
        setTimeoutDialogOpen(true);
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      }
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 1500);
    }
  };
  
  const handleProceed = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  
  return (
    <Box sx={{mt:4}}>
      <CardContent>
        
        {!state.submissionSuccess ? (
          <>
        <Typography variant='h6' sx={{mt:-6}}>
        Take the next step:
        </Typography>
            <FormGroup sx={{ mt: 2 }}>

              <FormControlLabel 
                control={
                  <Checkbox 
                    checked={value.receiveReport}
                    onChange={handleCheckboxChange}
                    name="receiveReport"
                  />
                } 
                label="Get your personalised report by email." 
              />

              {/* {state.netWorth >= CONFIG.QUALIFICATION_AMOUNT &&(<FormControlLabel 
                sx={{my:1}}
                control={
                  <Checkbox 
                    checked={value.requestCallback}
                    onChange={handleCheckboxChange}
                    name="requestCallback"
                  />
                } 
                label="Request callback for comprehensive Goal Planning & Asset Allocation." 
              />)} */}
            </FormGroup>
            
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
              <Button 
                variant="contained" 
                color="success"
                size="large"
                onClick={handleProceed}
                disabled={isSubmitting}
                fullWidth
                sx={{ 
                  py: 1.5,
                  fontWeight: 600,
                  borderRadius: 2
                }}
              >
                {isSubmitting ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'SUBMIT'
                )}
              </Button>
            </Box>
          </>
        ) : (
          <>
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            justifyContent: 'center', 
            // py: -4 
            my: -4
          }}>
            <Zoom in={true}>
              <CheckCircleIcon color="success" sx={{ fontSize: 64, mb:2}} />
            </Zoom>
            {/* {state.netWorth >= CONFIG.QUALIFICATION_AMOUNT ? ( */}
              <>
            <Typography variant="h6" sx={{mb: 2}}>
            Great Job, {state.clientName.split(" ")[0]} on taking the first step of planning your goals.
            </Typography>
            <Typography variant="h6" sx={{mb: 2}}>
            The next, and equally critical, step is aligning your <b style={{ color: '#1976d2' }}>asset allocation</b> with these goals.
            </Typography>
            <Typography variant="h6" sx={{mb: 2}}>
            Let’s take a closer look at your income, savings, and current investments to understand your starting point.
            </Typography>
            <Button
                variant="contained"
                color="success"
                size="large"
                endIcon={<ArrowForwardIcon />}
                onClick={() => {
                  actions.setStepperMode('assetAllocation');
                  actions.setActiveStepAsset(0); // start asset steps
                }}
                sx={{
                  borderRadius: 1,
                  py: 1.5,
                  textTransform: 'none',
                  fontWeight: 'bold'
                }}
              >
                Continue
            </Button></>
            {/*  ): 
             (<><Typography variant="h6" align="center" sx={{fontWeight:"bold"}}>
               Thank you, {state.clientName.split(" ")[0]} - for exploring your financial goals with us.
               </Typography>
               <Typography variant="body1" align="center">
               Your personalized report is on its way to your inbox.
               </Typography>
               <Typography variant="body1" align="center">
               We hope it brings you the clarity and confidence to move forward on your financial journey.
             </Typography></>)
             } */}
          </Box>
          </>
        )}

        {/* Confirmation Dialog */}
        <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth maxWidth="sm">
          <DialogTitle>Confirm Your Details</DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 2 }}>
              <TextField
                label="Your Full Name"
                value={state.clientName}
                onChange={(e) => actions.updateFormData('clientName', e.target.value)}
                fullWidth
                margin="normal"
                variant="outlined"
                required
              />
              <TextField
                label="Your Email"
                value={state.email}
                onChange={(e) => actions.updateFormData('email', e.target.value)}
                fullWidth
                margin="normal"
                variant="outlined"
                required
              />
              <TextField
                label="City"
                value={state.city || ''}
                onChange={(e) => actions.updateFormData('city', e.target.value)}
                fullWidth
                margin="normal"
                variant="outlined"
                required
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button onClick={handleDialogClose} color="inherit">
              Cancel
            </Button>
            <Button 
              onClick={() => {
                handleDialogClose();
                handleSubmit();
                if (window.gtag) {
                  window.gtag('event', 'PLANGOALS_form_submit', {
                  event_category: 'lead',
                  event_label: 'portal_form'
                      });
                }
              }} 
              variant="contained" 
              color="success"
              disabled={!state.city.trim() || !state.clientName || !state.email}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </CardContent>
      <Dialog open={timeoutDialogOpen} onClose={() => {}} fullWidth maxWidth="xs">
        <DialogTitle>Session Timeout</DialogTitle>
        <DialogContent>
          <Typography>
            You took too much time to submit the request. Reloading the page...
          </Typography>
        </DialogContent>
      </Dialog>
      </Box>
      
  );
}

export default SubmitPage;
